module.exports = __webpack_public_path__ + "static/media/Profile1.5d13df1e.svg";